<template>
  <div class="goods-actions van-hairline--top">
    <template v-if="showDefStatus">
      <div class="normal-actions">
        <div class="icon-entry">
          <div class="service-entry">
            <!-- <router-link to="/contactService"> -->
            <img
              src="../assets/img/goods-details/service-icon.png"
              @click="fetchCustomerService"
            />
            <!-- </router-link> -->
          </div>
          <div class="shoping-cart">
            <router-link to="/shopingTrolley">
              <img alt src="../assets/img/goods-details/cart-icon.png" />
            </router-link>
          </div>
          <button class="gift-icon" @click="send" v-if="giftStatus">
            <img alt src="../assets/img/gift-icon.png" />
          </button>
        </div>
        <div class="actions">
          <button
            :disabled="!goodsInventoryStatus"
            @click="add"
            class="add-to-shoping-cart"
          >
            加入购物车
          </button>
          <button
            :disabled="!goodsInventoryStatus"
            @click="buy"
            class="shop-now"
          >
            立即购买
          </button>
        </div>
      </div>
    </template>
    <template v-else-if="showZeroStatus">
      <button @click="freeReceive" class="get">领取</button>
    </template>

    <van-popup v-model="servicePopup.show">
      <div class="popup-content">
        <div class="content-box">
          <div class="service-box">
            <img
              class="icon-service"
              src="../assets/img/goods-details/icon-service.png"
              alt=""
            />
          </div>

          <div class="top">
            <div>客服时间：9:00-18:00</div>
            <div style="margin-top: 0.1rem">请在客服时间内拨打客服电话</div>
            <div style="margin-top: 0.1rem">平台客服电话：400-6687017</div>
          </div>
          <div class="divder"></div>
          <div class="bottom" v-html="servicePopup.content"></div>
        </div>
        <div class="btn-box flex-center">
          <van-button class="btn cancel" @click="servicePopup.show = false"
            >知道了</van-button
          >
          <van-button class="btn confirm" @click="openChat"
            >在线客服</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup, Button } from 'vant'

export default {
  name: 'goods-actios',
  components: {
    VanPopup: Popup,
    VanButton: Button
  },
  props: {
    actionType: {
      type: [Number, String]
    },
    goodsInventoryStatus: {
      type: Boolean
    },
    giftStatus: {
      type: Boolean,
      default: false
    },
    tximUserid: {
      type: String,
      require: true
    },
    vendorId: {
      type: [String, Number],
      require: true
    }
  },
  data () {
    return {
      zeroBuyTypes: ['all_zero', 'member_zero'],
      types: ['discount', 'member', 'invite', 'time_rush', 'half_price', 'cash_rebate', 0],
      servicePopup: {
        show: false,
        content: ''
      }
    }
  },
  computed: {
    showZeroStatus () {
      return this.zeroBuyTypes.includes(this.actionType)
    },
    showDefStatus () {
      return this.types.includes(this.actionType)
    }
  },
  methods: {
    // 加购
    add () {
      this.$emit('on-add', true)
    },

    // 送礼
    send () {
      this.$emit('on-send-gift', true)
    },

    // 购买
    buy () {
      this.$emit('on-buy', true)
    },

    // 领取
    freeReceive () {
      this.$emit('free-receive', true)
    },
    // 获取客服配置
    async fetchCustomerService () {
      const res = await this.$axios.get(`/api/goods/vendor/info/${this.vendorId}`)
      const { code, data } = res.data
      if (code === 0) {
        this.servicePopup.show = true
        this.servicePopup.content = data.service_info
      } else {
        this.openChat()
      }
    },
    // 打开与商家聊天
    async openChat () {
      if (!this.tximUserid) {
        location.href = process.env.VUE_APP_ONLINE_SERVICE
        // location.href = 'https://v1.live800.com/live800/chatClient/chatbox.jsp?companyID=1253419&configID=47771&jid=1020280997&s=1'
      } else {
        // this.$emit('openChat')
        location.href = process.env.VUE_APP_ONLINE_SERVICE
        // this.$router.push({ name: 'MessageDetails', query: { userID: `C2C${this.tximUserid}` } })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.goods-actions {
  position: fixed;
  bottom: 0;
  width: 100%;
  font-size: @fz26;
  z-index: 9;
  height: 0.88rem;
  background-color: #fff;
  .safe-area-inset-bottom;
  .normal-actions {
    width: 100%;
    height: 100%;
    .flex-between;
    background-color: #fff;
    .icon-entry {
      display: flex;
      .service-entry,
      .gift-icon,
      .shoping-cart {
        padding-left: 0.3rem;
      }
      img {
        width: 0.6rem;
        height: 0.6rem;
        object-fit: contain;
      }
    }
    .actions {
      padding-right: 0.2rem;
      button {
        width: 1.8rem;
        height: 0.64rem;
        color: #fff;
      }
      .add-to-shoping-cart {
        background-color: #ffbb00;
        border-radius: 30px 0 0 30px;
        &:disabled {
          background-color: #c1c1c1;
        }
      }
      .shop-now {
        background-color: #fe3b3b;
        border-radius: 0 30px 30px 0;
        &:disabled {
          background-color: #a5a5a5;
        }
      }
    }
  }

  // 领取
  .get {
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: @fz32;
    letter-spacing: 10px;
    background-color: #fe3b3b;
  }
  .van-popup {
    background: transparent;
  }
  .popup-content {
    width: 5.9rem;
    background: #fff url("../assets/img/goods-details/bg-popup.png") no-repeat
      left top / 100% auto;
    padding: 2rem 0 0.4rem;
    border-radius: 0.1rem;

    .content-box {
      width: 4.98rem;
      background: #ffffff;
      margin: 0 auto;
      padding: 0.72rem 0.2rem 0.4rem;
      box-sizing: border-box;
      border-radius: 0.1rem;
      box-shadow: 0 0.04rem 0.2rem 0 rgba(0, 0, 0, 0.1);
      position: relative;

      .service-box {
        width: 1.38rem;
        height: 1.38rem;
        background: #ffffff;
        padding: 0.2rem 0.25rem 0;
        border-radius: 50%;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        right: 0;
        top: -0.64rem;
        margin: auto;

        .icon-service {
          width: 0.88rem;
          height: 0.84rem;
        }
      }

      .top {
        font-size: 0.28rem;
        color: #e74a50;
        text-align: center;
      }
      .divder {
        height: 0.01rem;
        background: #dddddd;
        margin: 0.4rem auto 0.2rem;
      }
      .bottom {
        max-height: 3rem;
        overflow: scroll;
        font-size: 0.28rem;
        color: #333333;
      }
    }
    .btn-box {
      margin-top: 0.5rem;
      .btn {
        width: 2.43rem;
        height: 0.7rem;
        line-height: initial;
        border: none;
        border-radius: 0.35rem;
        font-size: 0.32rem;

        & + .btn {
          margin-left: 0.35rem;
        }
        &.cancel {
          background: url("../assets/img/goods-details/btn-02.png") no-repeat
            left top / 100% 100%;
          color: #d07718;
        }
        &.confirm {
          background: url("../assets/img/goods-details/btn-01.png") no-repeat
            left top / 100% 100%;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
